import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { system900 } from 'Mui/styles/color';
import FeverIconButton from 'components/common/Button/FeverIconButton';

const ShareIconButton = ({
    variant,
    text,
    textColor = system900.color,
    bgColor,
    imageUrl,
    url,
    icon: Icon,
    size = 36,
    style,
    isExternal = true,
    onClick,
    isFetchingData,
    isEditor = false,
    iconStyle
}) => {
    const handleClick = event => {
        if (isEditor) return;
        if (typeof onClick === 'function') onClick(event);
        if (url && isExternal) {
            window.open(url, '__blank');
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <FeverIconButton
                bgColor={bgColor}
                imageUrl={imageUrl}
                link={url}
                icon={Icon}
                iconVariant={variant}
                iconSize={size}
                iconButtonStyle={[shareButtonStyle, style]}
                onClick={handleClick}
                disabled={isFetchingData}
                iconStyle={iconStyle}
            />
            <Typography
                variant="subtitle2"
                css={shareButtonTextStyle}
                style={{ marginTop: 4, textAlign: 'center', color: textColor }}
            >
                {text}
            </Typography>
        </div>
    );
};

export default ShareIconButton;

ShareIconButton.propTypes = {
    variant: PropTypes.oneOf(['default', 'outlined', 'contained']),
    text: PropTypes.string,
    imageUrl: PropTypes.string,
    url: PropTypes.string,
    icon: PropTypes.object,
    size: PropTypes.number,
    style: PropTypes.object,
    onClick: PropTypes.func
};

const shareButtonTextStyle = css`
    margin-top: 4px
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.4px;
    text-transform: capitalize;
`;

const shareButtonStyle = css`
    &.MuiButtonBase-root.Mui-disabled {
        background-color: #ffffff;
    }
`;
